<script setup lang="ts">
import { useI18n } from 'vue-i18n'

type SpinnerSize = 'sm' | 'md' | 'lg'

const {
  size = 'md',
  center = false,
  color = 'var(--color-green-40)',
} = defineProps<{
  size?: SpinnerSize
  center?: boolean
  color?: string
}>()

const { t } = useI18n()

const spinnerSize = {
  sm: 'size-6',
  md: 'size-12',
  lg: 'size-16'
} as const satisfies Record<SpinnerSize, string>
</script>

<template>
  <div
    class="inline-block"
    :class="[spinnerSize[size], { 'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2': center }]"
    role="status"
    tabindex="0"
  >
    <div class="size-full animate-spin rounded-full border-4 !border-r-transparent" :style="{ borderColor: color }">
      <span class="sr-only" v-text="t('loading')" />
    </div>
  </div>
</template>
